module.exports = __webpack_public_path__ + "static/media/BQ.a3906d5a.svg";